(function (global) {
    'use strict';

    global.MeloApps = global.MeloApps || {};

    /**
     * Mock repository — reads from MELO_APPS_CATALOG (generated from JSON).
     * Replace via composition-root when connecting a real data source.
     */
    function MockMeloAppsRepository(catalog) {
        var apps = (catalog && catalog.apps) || [];

        this.getAll = function () {
            return apps.slice();
        };

        this.getBySlug = function (slug) {
            return apps.find(function (app) {
                return app.slug === slug;
            }) || null;
        };
    }

    global.MeloApps.MockMeloAppsRepository = MockMeloAppsRepository;
})(typeof window !== 'undefined' ? window : global);
